import "./DataLoader.css";

export function DataLoader({
  customStyle = {},
}: {
  customStyle?: React.CSSProperties;
}) {
  return (
    <div className="data-loader-container" style={customStyle}>
      <img
        src="/images/loader.png"
        height={28}
        width={28}
        className="loader-spin"
      />
    </div>
  );
}
